module.exports = __webpack_public_path__ + "img/header-weddingRingsPlain.d4bef2f.jpg";